import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'
import UrlBuilder from 'app/utils/UrlBuilder'
import { generateDownloadFileName, downloadFile } from 'app/utils/utils';

const initialState = {    
    cashes : [],
    cashReport: null,
    status: HTTP_STATUS.IDLE,
    deleteStatus: HTTP_STATUS.IDLE
}

export const fetchCashesBySales = createAsyncThunk('cash/get-cash-by-sales', async (salesId, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(BASE_URL + `/api/Cash/get-by-sales/${salesId}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchCashReport = createAsyncThunk('cash/get-cash-report', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().filter(data, 'fileType').filter(data, 'stDate').filter(data, 'enDate').filter(data, 'repId').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Cash/cash-report${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createCashes = createAsyncThunk('cash/create', async (postdata = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Cash', postdata)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const removeCashes = createAsyncThunk('cash/remove', async (id = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(BASE_URL + `/api/Cash/${id}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})



export const Cash = createSlice({
    name: 'cash',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        },
        resetCashes: (state, action) => {
            state.cashes = [];
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCashesBySales.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchCashesBySales.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.cashes = action.payload
            })
            .addCase(fetchCashesBySales.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(removeCashes.pending, (state, action) => {
                state.deleteStatus = HTTP_STATUS.LOADING
            })
            .addCase(removeCashes.fulfilled, (state, action) => {
                state.deleteStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(removeCashes.rejected, (state, action) => {
                state.deleteStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchCashReport.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchCashReport.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.cashReport = action.payload
            })
            .addCase(fetchCashReport.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            
    }
})

export const getCashes = (state) => state.cash.cashes;
export const getCashReport = (state) => state.cash.cashReport;
export const getCashesStatus = (state) => state.cash.status;
export const getDeleteCashestatus = (state) => state.cash.deleteStatus;
export const CashActions = Cash.actions

export default Cash.reducer